import { LOGIN_COOKIE_NAME, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, USER_COOKIE_NAME, USER_COOKIE_THROTTLE_TIME, LOGIN_PATH, API_PATH, CASH_PICKUP_REQUEST_PATH, CREDIT_PICKUP_REQUEST_PATH, BOOKING_REQUEST_PATH, APP_TYPE_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, USER_TYPE_COOKIE_NAME, EP, AD, US, MMB_LIVE, MMB, MASTER_IMPORT_RATE, MASTER_NETWORK, MASTER_SERVICE, MASTER_CITY, MASTER_AREA, MASTER_Country, MASTER_STATE, MASTER_CLIENT, MASTER_IMPORT_RATE_FOR_LOGISTIC, MASTER_CLIENT_VAS, MASTER_TATDYS, MASTER_CLIENTSERIESRATE, MASTER_SERVICEASSOCIATE, COMMON_LOADSHIPPERDETAIL, COMMON_LOADRECIEVERDETAIL, MASTER_TAXSERIES, MASTER_BRANCH, MASTER_Company } from "mmbclient/Common/CommonVariable";
import { getCookie, handleLogOut, setLoggedIn, setLoginCookie, setUserCookie } from "mmbclient/Common/CommonFunctions";
import 'mmbclient/Common/GlobalVariable';






// ---------------------------------------- http service for logged in user ----------------------------------------

export const checkSession = async (store) => {
    // const store = useContext(GLOBAL_CONTEXT);

    // console.log(store);        
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    // console.log('cookie : ' + cookie);

    // ------ validate session cookie -----------start----
    const sessionCookie = getCookie(LOGIN_SESSION_NAME);
    if (cookie !== '') {
        // debug
        // get session value from db
        let c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
        if (c.length === 4) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    userKey: c[0],
                    userCode: c[1],
                    sessionId: sessionCookie,
                })
            };

            const path = API_PATH + LOGIN_PATH + "loginsession";
            // console.log(path);
            const res = await fetch(path, requestOptions);
            const data = await res.json();
            if ("Entry Not Saved." === data) {
                handleLogOut(store);
                return;
            }
        } else {
            handleLogOut(store);
            return;
        }

        // if not matched with sessionCookie
        // then set cookie = '';
    }

    // ------ validate session cookie -----------end------

    if (cookie === '') {
        handleLogOut(store);
        // console.log('11111111');
    } else {
        let c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        // console.log(c);
        if (c.length === 4) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    userKey: c[0]
                })
            };

            const path = API_PATH + LOGIN_PATH + "checksession";
            const res = await fetch(path, requestOptions);
            const data = await res.json();
            // console.log(data);
            if (data === 'Entry Saved.') {
                global.ClientName2 = c[2];
                setLoggedIn(store);
                setUserCookie(USER_COOKIE_NAME, getCookie(USER_COOKIE_NAME), USER_COOKIE_THROTTLE_TIME);
                const loginCookie = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
                if (loginCookie.length === 4) {
                    const loginId = loginCookie[0];
                    const clientCode = loginCookie[1];
                    const clientName = loginCookie[2];
                    const brnCode = loginCookie[3];
                    setLoginCookie(LOGIN_COOKIE_NAME, loginId, clientCode, clientName, brnCode, LOGIN_THROTTLE_TIME);
                }
            } else {
                handleLogOut(store);
                return;
                // console.log('22222222');
            }
        } else {
            handleLogOut(store);
            return;
            // console.log('333333333');
        }
    }
}

export const getCityNameFromPincode = async (store, pincode) => {

    if (isNaN(pincode) === false && pincode.length === 6) {
        const cookie = getCookie(LOGIN_COOKIE_NAME);
        if (cookie === '') {
            handleLogOut(store);
        } else {
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)

            if (c.length === 4) {
                const query = { "userKey": c[0], "pincode": pincode };
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query)
                    })
                };
                const res = await fetch(API_PATH + CREDIT_PICKUP_REQUEST_PATH + "getcityname", requestOptions)
                const data = await res.json();
                const response = JSON.parse(data)[0].Data;
                if (response[0].city_name !== '') {
                    return response[0].city_name;
                } else {
                    handleLogOut(store);
                }

            } else {
                handleLogOut(store);
            }
        }
    }
}

export async function getPincodeDetails(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)

        if (c.length === 4) {
            const query = { "userKey": c[0] };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + CREDIT_PICKUP_REQUEST_PATH + "getpincodedetails", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].Data;
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getCountryDetails(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)

        if (c.length === 4) {
            const query = { "userKey": c[0], "userType": getCookie(APP_TYPE_COOKIE_NAME) };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + CREDIT_PICKUP_REQUEST_PATH + "getcountrydetails", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].Data;
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getNetworkDetails(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userKey = c[0];
        const branchCode = c[3];

        let condition = "";
        if (c.length === 4) {
            if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                condition = " order by network_name";
            }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                condition = " where brn_code = '" +branchCode + "' order by network_name";
            }
            const query = { "userKey": userKey, "condition": condition };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + CREDIT_PICKUP_REQUEST_PATH + "getnetworkdetails", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].Data;
            // console.log('network : ------------------ ');
            // console.log(response);
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getServiceDetails(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
        const userKey = c[0];

        if (c.length === 4) {
            const query = { "userKey": userKey };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + CREDIT_PICKUP_REQUEST_PATH + "getservicedetails", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].Data;
            // console.log('service : ------------------ ');
            // console.log(response);
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getAllClients(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    const beanName = "ClientBean";
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userKey = c[0];
        // const branchCode = c[3];

        if (c.length === 4) {
            const query = { "userKey": userKey, "appType": getCookie(APP_TYPE_COOKIE_NAME), "beanName": beanName };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + BOOKING_REQUEST_PATH + "getclients", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].ClientBean;
            // console.log('network : ------------------ ');
            // console.log(response);
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getClientDetail(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    const beanName = "ClientBean";
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userKey = c[0];
        const clientCode = c[1];

        if (c.length === 4) {
            const query = { "userKey": userKey, "appType": getCookie(APP_TYPE_COOKIE_NAME), "clientCode": clientCode, "beanName": beanName };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + BOOKING_REQUEST_PATH + "getclientdetail", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].ClientBean;
            // console.log('network : ------------------ ');
            // console.log(response);
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getClientAllDetail(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    const beanName = "ClientBean";
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userKey = c[0];
        const clientCode = c[1];

        if (c.length === 4) {
            let condition  ='';
            if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                
            }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                condition = "where client_code ='" +clientCode +"'";
            }
            const query = { "userKey": userKey, "appType": getCookie(APP_TYPE_COOKIE_NAME), "condition": condition, "beanName": beanName };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + BOOKING_REQUEST_PATH + "getclientalldetail", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].ClientBean;
            // console.log('network : ------------------ ');
            // console.log(response);
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getClientContactDetails(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userKey = c[0];
        const clientCode = c[1];

        if (c.length === 4) {
            const query = { "userKey": userKey, "clientCode": clientCode };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + CREDIT_PICKUP_REQUEST_PATH + "getclientcontactdetails", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].Data;
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getConsignorDetails(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)

        if (c.length === 4) {
            const query = { "userKey": c[0] };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + CREDIT_PICKUP_REQUEST_PATH + "getconsignordetails", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].Data;
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}

export async function getConsigneeDetails(store) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    if (cookie === '') {
        handleLogOut(store);
    } else {
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)

        if (c.length === 4) {
            const query = { "userKey": c[0], "userType": getCookie(APP_TYPE_COOKIE_NAME) };
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query)
                })
            };
            const res = await fetch(API_PATH + CREDIT_PICKUP_REQUEST_PATH + "getconsigneedetails", requestOptions);
            const data = await res.json();
            const response = JSON.parse(data)[0].Data;
            if (response.length > 0) {
                return response;
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
            handleLogOut(store);
        }
    }
}







// ---------------------------------------- http service for non-logged in user ----------------------------------------

export async function getCashPincodeDetails(key) {

    const query = { "userKey": key };
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: new URLSearchParams({
            query: JSON.stringify(query)
        })
    };
    const res = await fetch(API_PATH + CASH_PICKUP_REQUEST_PATH + "getpincodedetails", requestOptions);
    const data = await res.json();
    const response = JSON.parse(data)[0].Data;
    if (response.length > 0) {
        return response;
    }
}

export async function getCashConsignorDetails(key) {

    const query = { "userKey": key };
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: new URLSearchParams({
            query: JSON.stringify(query)
        })
    };
    const res = await fetch(API_PATH + CASH_PICKUP_REQUEST_PATH + "getconsignordetails", requestOptions);
    const data = await res.json();
    const response = JSON.parse(data)[0].Data;
    if (response.length > 0) {
        return response;
    }
}

export async function getCashConsigneeDetails(key) {
    try {
        const query = { "userKey": key };
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: new URLSearchParams({
                query: JSON.stringify(query)
            })
        };
        const res = await fetch(API_PATH + CASH_PICKUP_REQUEST_PATH + "getconsigneedetails", requestOptions);
        if (!res.ok) {
            throw new Error("connnection error");
        }
        const data = await res.json();
        const response = JSON.parse(data)[0].Data;
        if (response.length > 0) {
            return response;
        }
    } catch (err) {
        console.log(err.message);
    }
}

//=============================================================================================================================

export async function getRateMasterNewFromDb(clientcode) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "ImportRateBean";
            if(userType===MMB_LIVE){
            column = "sno,client_code,network_code,service_code,client_type,rate_type,slab,add_limit,zone_type,zone_code,rate"
                    + "";
            condition = " where client_code='" + clientcode + "' order by zone_type,rate_type,slab";
            tableName = "rate_master_new";
            }else if(userType===MMB) {

            }

            const query = { "userKey": c[0],"column": column,"value":condition,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_IMPORT_RATE + "getData", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.ImportRateBean || [];
            if (response.length > 0) {
                // console.log("ImportRateBean response: ",response)
                return response;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getRateFromDbForLogistic(clientcode) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "ImportRateBean";
            if(userType===MMB_LIVE){
            column = "client_code, network_code, service_group_code as service_code, origin_zone, destination_zone, rate";
            condition = " where client_code='" + clientcode + "'";
            tableName = "rate_master_kg_new";
            }else if(userType===MMB) {

            }

            const query = { "userKey": c[0],"column": column,"value":condition,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_IMPORT_RATE_FOR_LOGISTIC + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.ImportRateBean || [];
            if (response.length > 0) {
                // console.log("ImportRateBean response: ",response)
                return response;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getNetworkDataFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "NetworkBean";
            if(userType===MMB_LIVE){
            column = "All";
            tableName = "view_loadallnetworkdata";
            }else if(userType===MMB) {
                column = "All";
            condition = "where web_status = 'T'"     
            tableName = "view_loadallnetworkdata";
            // console.log("from network",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data,'value':condition};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_NETWORK + "getData", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.NetworkBean || [];
            if (response.length > 0) {
                // console.log("NetworkBean response: ",response)
                return response;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getServiceDataFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "ServiceBean";
            if(userType===MMB_LIVE){
                column = "All";
                condition = "order by ser_name"
                tableName = "view_loadallservicedata";
            }else if(userType===MMB) {
                column = "All";
                condition = "where web_status = 'T' order by ser_name"
                tableName = "view_loadallservicedata";
                // console.log("from service",userType)
            }

            const query = { "userKey": c[0],"column": column,'value':condition,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_SERVICE + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.ServiceBean || [];
            if (response.length > 0) {
                // console.log("ServiceBean response: ",response)
                return response;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getAllCityDataFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "CityMaster";
            if(userType===MMB_LIVE){
            column = "city_code,city_name,state_code";
            condition = "where city_code!= '' and city_name!=''  group by city_code";
            tableName = "city_master";
            }else if(userType===MMB) {

            }

            const query = { "userKey": c[0],"column": column,"value":condition,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_CITY + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.CityMaster || [];
            if (response.length > 0) {
                // console.log("CityMaster response: ",response)
                return response;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getAllPincodeFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "PincodeBean";
            if(userType===MMB_LIVE){
                column = "All";
                tableName = "view_pincodestatecity";
            }else if(userType===MMB) {
                column = "All";
                tableName = "view_pincodestatecity";
                // console.log("from pincode",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_AREA + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.PincodeBean || [];
            if (response.length > 0) {
                // console.log("PincodeBean response: ",response)
                return response;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getAllCountryDataFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "CountryBean";
            if(userType===MMB_LIVE){
            column = "All";
            tableName = "view_loadallcountrydata";
            }else if(userType===MMB) {

            }

            const query = { "userKey": c[0],"column": column,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_Country + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.CountryBean || [];
            if (response.length > 0) {
                // console.log("CountryBean response: ",response)
                return response;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getAllStateDataFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "StateBean";
            if(userType===MMB_LIVE){
            column = "country_code,state_name,state_code,state_code_number";
            condition = "where state_code!= '' group by state_code,country_code,state_name,state_code_number";
            tableName = "view_pincodestatecity";
            }else if(userType===MMB) {
            column = "country_code,state_name,state_code,state_code_number";
            condition = "where state_code!= '' group by state_code,country_code,state_name,state_code_number";
            tableName = "view_pincodestatecity";
            }

            const query = { "userKey": c[0],"column": column,"value":condition,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_STATE + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.StateBean || [];
            if (response.length > 0) {
                // console.log("StateBean response: ",response)
                return response;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getClientViewDataFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "ClientMaster";
            if(userType===MMB_LIVE){
            column = "All";
            if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                condition = "order by client_name"
            }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                condition = "where client_code ='" +c[1] +"'";
            }
            tableName = "view_loadallclientdata";
            }else if(userType===MMB) {
                column = "All";
                if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                    condition = "order by client_name"
                }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                    condition = "where client_code ='" +c[1] +"'";
                }
                tableName = "view_loadallclientdata"
                // console.log("from",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"value":condition,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_CLIENT + "getData", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.ClientMaster || [];
            if (response.length > 0) {
                // console.log("ClientMaster response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}

export async function getClientVasViewDataFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "ClientVasMaster";
            if(userType===MMB_LIVE){
            column = "All";
            if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                
            }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                condition = "where client_code ='" +c[1] +"'";
            }
            tableName = "view_loadallclientvasdatafromdb";
            }else if(userType===MMB) {
            column = "All";    
                if(getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP){
                
                }else if(getCookie(USER_TYPE_COOKIE_NAME) === US){
                    condition = "where client_code ='" +c[1] +"'";
                }
            tableName = 'view_loadallclientvasdatafromdb'
            // console.log("from vas client",userType,tableName)    
            }

            const query = { "userKey": c[0],"column": column,"value":condition,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_CLIENT_VAS + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.ClientVasMaster || [];
            if (response.length > 0) {
                // console.log("ClientVASMaster response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}

export async function getTatDaysFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "TatDays";
            if(userType===MMB_LIVE){
            column = "zone_code,service_code,tat_days";
            tableName = "tat_days_master";
            }else if(userType===MMB) {
                column = 'zone_code,service_code,tat_days'
                tableName = "tat_days_master"
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_TATDYS + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.TatDays || [];
            if (response.length > 0) {
                // console.log("tatedays response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}

export async function getClientSeriesRateFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "ClientSeriesRate";
            if(userType===MMB_LIVE){
            column = "client_code,series,amount";
            tableName = "client_series_rate";
            }else if(userType===MMB) {

            }

            const query = { "userKey": c[0],"column": column,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_CLIENTSERIESRATE + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.ClientSeriesRate || [];
            if (response.length > 0) {
                // console.log("client sereres rate response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}

export async function loadAllMasterData(masterData) {
    
        try{
            const client = await getClientViewDataFromDb();
            // const state = await getAllStateDataFromDb();
            // const c= await getAllCountryDataFromDb();
            const pincode= await getAllPincodeFromDb();
            // const e= await getAllCityDataFromDb();
            const clientVas = await getClientVasViewDataFromDb();
            const service = await getServiceDataFromDb();
            const network = await getNetworkDataFromDb();
            masterData.setLIST_CLIENT(client);
            // masterData.setLIST_STATE(state)
            masterData.setLIST_CLIENTVAS(clientVas)
            masterData.setLIST_SERVICE(service)
            masterData.setLIST_PINCODE(pincode);
            masterData.setLIST_NETWORK(network)
            masterData.setIsClientLoaded(true);
        }catch(err){
            masterData.setIsClientLoaded(false);
        }
        console.log("called")
}


export async function getServiceAssociatMMBDataFromDb(network,service) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
    
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY)
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        if (c.length === 4) {

            let column = '';
            let condition = '';
            let tableName = '';
            let Data = "ServiceAssociatBean";
            if(userType===MMB_LIVE){
                return [];
            }else if(userType===MMB) {
                column = "ser_dimenson";
                condition = " where network_cd='" + network + "' AND service_cd='" + service + "'";
                tableName = "service_associate";
                // console.log("from service",userType)
            }

            const query = { "userKey": c[0],"column": column,'value':condition,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            // console.log(condition)
            const res = await fetch(API_PATH + MASTER_SERVICEASSOCIATE + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.ServiceAssociatBean || [];
            if (response.length > 0) {
                // console.log("ServiceAssociatBean response: ",response)
                return response[0].ser_dimenson;
            }else{
                return [];
            }
            // else {
            //     handleLogOut(store);
            // }

        } else {
        }
}

export async function getShipperDataMMBFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let tableName = '';
            let Data = "shipper_detail";
            if(userType===MMB_LIVE){
                return;
            }else if(userType===MMB) {
                column = "ship_ph,ship_name,ship_addrs,ship_zip,ship_city,ship_state";
                tableName = "shipper_detail"
                // console.log("from",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tablename:tableName
                })
            };
            const res = await fetch(API_PATH + COMMON_LOADSHIPPERDETAIL + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.shipper_detail || [];
            if (response.length > 0) {
                // console.log("ClientMaster response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}

export async function getRecieverDataMMBFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let tableName = '';
            let Data = "recevier_detail";
            if(userType===MMB_LIVE){
                return;
            }else if(userType===MMB) {
                column = "recv_ph,recv_name,recv_addrs,recv_zip,recv_city,recv_state";
                tableName = "recevier_detail"
                // console.log("from",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tablename:tableName
                })
            };
            const res = await fetch(API_PATH + COMMON_LOADRECIEVERDETAIL + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.recevier_detail || [];
            if (response.length > 0) {
                // console.log("ClientMaster response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}

export async function getTaxSeriesFromDb() {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let tableName = '';
            let condition = '';
            let Data = "service_tax_master";
            if(userType===MMB_LIVE){
                return;
            }else if(userType===MMB) {
                column = " tax_name, tax_rate,edu_name,edu_cess_rate,h_edu_name,higher_cess_rate ";
                condition = " order by tax_date desc limit 1 "
                tableName = " service_tax_master "
                // console.log("from",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data,"value":condition};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_TAXSERIES + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.service_tax_master || [];
            if (response.length > 0) {
                // console.log("service_tax_master response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}

export async function getBranchFromDb(brnCode) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let tableName = '';
            let condition = '';
            let Data = "branch_master";
            if(userType===MMB_LIVE){
                return;
            }else if(userType===MMB) {
                    column = " branch_cd,city,company_cd ";
                    condition = " where  company_cd='" + brnCode + "'";
                    tableName = " branch_master "
                // console.log("from",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data,"value":condition};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_BRANCH + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.branch_master || [];
            if (response.length > 0) {
                console.log("branch response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}

export async function getCompanyFromDb(brnCode) {
    const cookie = getCookie(LOGIN_COOKIE_NAME);
        const userType = getCookie(APP_TYPE_COOKIE_NAME);
        const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);
    try {
            let column = '';
            let tableName = '';
            let condition = '';
            let Data = "company_detail";
            if(userType===MMB_LIVE){
                return;
            }else if(userType===MMB) {
                    column = " branch_cd as companyCode,stateCode ";
                    condition = " where  branch_cd='" + brnCode + "'";
                    tableName = " company_detail "
                // console.log("from",userType,tableName)
            }

            const query = { "userKey": c[0],"column": column,"beanname":Data,"value":condition};
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: new URLSearchParams({
                    query: JSON.stringify(query),
                    key:"checkService",
                    tableName:tableName
                })
            };
            const res = await fetch(API_PATH + MASTER_Company + "getdata", requestOptions);
            const data = await res.json();
            const response = data?.[0]?.company_detail || [];
            if (response.length > 0) {
                console.log("branch response: ",response)
                return response;
            }else{
                return [];
            }
    } catch (err) {
        console.log(err.message);
    }
}